// @ts-nocheck
import React from 'react';
import { CellInfo } from 'react-table';
import cx from 'classnames';
import FormatAPIDate from '../shared/format-api-date';
import DeleteModalButton from './delete-modal-button';
import { Member } from '../models/member';
import { Role } from '../models/role';
import TableWrapper from '../shared/table-wrapper';
import { EditIcon } from '../icons';
import css from '../shared/css';
import AppVersionCell from './utils/app-version-cell';

interface Props {
  data: Member[];
  userRoles: Role[];
  onEditClick: (memberId: string) => void;
  onOpenClick: (member: Member) => void;
  isOwner: boolean;
}

const MemberTable = ({ ...props }: Props) => {
  const ownerRoles = props.userRoles.filter((role) => role.can_manage_roles);
  const ownerRoleIDs = !ownerRoles.length ? [] : ownerRoles.map((role) => role.id);

  return (
    <TableWrapper
      data={props.data}
      className={styles.tableHeaders}
      columns={[
        {
          Cell: (row) => (
            memberName(row.original)
          ),
          Header: 'Name',
          accessor: 'first_name',
        },
        {
          Header: 'Email',
          accessor: 'email',
          minWidth: 125,
        },
        {
          Header: 'Role',
          accessor: 'role_name',
        },
        {
          Cell: (row) => (
            FormatAPIDate(row.value)
          ),
          Header: 'Joined At',
          accessor: 'created_at',
          minWidth: 100,
        },
        {
          Cell: (row) => (
            FormatAPIDate(row.value)
          ),
          Header: 'Last Sync',
          accessor: 'device_info.last_sync',
          minWidth: 100,
        },
        {
          Cell: (row) => (
            FormatAPIDate(row.value)
          ),
          Header: 'Last Sign In',
          accessor: 'last_sign_in_at',
          minWidth: 100,
        },
        {
          Cell: (row) => (
            appPlatform(row)
          ),
          Header: 'Device Platform',
          accessor: 'device_info',
        },
        {
          Header: 'Device Model',
          accessor: 'device_info.model',
        },
        {
          Cell: (row) => (
            <AppVersionCell value={row?.original?.device_info} />
          ),
          Header: 'App Version',
          accessor: 'device_info.app_version',
        },
        {
          Header: 'IP Address',
          accessor: 'device_info.ip_address',
        },
        {
          Cell: (row) => (
            editButton(row, props.onEditClick)
          ),
          accessor: 'id',
          maxWidth: 50,
        },
        {
          Cell: (row) => (
            deleteModalButton(row, props.isOwner, ownerRoleIDs, props.onOpenClick)
          ),
          maxWidth: 50,
          accessor: 'delete',
        },
      ]}
    />
  );
};

const appPlatform = (row: CellInfo) => {
  const { value } = row;
  return (
    <div>
      {value ? `${value.platform} ${value.platform_version}` : null}
    </div>
  );
};

const editButton = (row: CellInfo, onClick) => (
  <a
    data-tip="Edit"
    onClick={() => onClick(row.value)}
    className={cx(styles.iconContainer, 'btn btn-quiet outlined small')}
  >
    <EditIcon
      className={styles.editIcon}
      width="14"
      color="#41403b"
    />
  </a>
);

const deleteModalButton = (row: CellInfo, userIsOwner, roleIDs, onClick) => {
  const isOwnerRow = roleIDs.includes(row.original.role_id);

  return (
    <DeleteModalButton
      onOpenClick={onClick}
      member={row.original}
      disabled={!userIsOwner && isOwnerRow}
    />
  );
};

const memberName = (value: CellInfo['original']) => (
  <div>
    {value.is_managed ? `${value.user} (Managed)` : value.user}
  </div>
);

export default MemberTable;

const styles = css({
  tableHeaders: {
    textTransform: 'uppercase',
  },
  iconContainer: {
    background: 'transparent !important',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 2,
    borderColor: 'transparent !important',

    ':hover': {
      background: '#f7f7f7 !important',
      borderColor: '#eee !important',
    },
  },
  editIcon: {
    position: 'relative',
    top: 1,
  },
});
